import React from 'react';

const Tuition = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        <div className="text-3xl font-bold mb-4">Tuition & Fees</div>
        <p className="mb-4">Payment for tuition and fees are due prior to the start of each course.</p>

        <table className="w-full border-collapse mb-4">
          <tbody>
            <tr>
              <td className="border p-2">Undergraduate programs - per credit hour is $250.00</td>
            </tr>
            <tr>
              <td className="border p-2">All Religious programs per credit hour is $250.00. MBA course per credit hour is $325.00</td>
            </tr>
            <tr>
              <td className="border p-2">MBA course per credit hour is $325.00</td>
            </tr>
            <tr>
              <td className="border p-2">DBA & PhD per credit hour is $475.00</td>
            </tr>
            <tr>
              <td className="border p-2">Other fees (applicable to all programs)</td>
            </tr>
            <tr>
              <td className="border p-2">Registration fee, $50 USD per term</td>
            </tr>
            <tr>
              <td className="border p-2">Late payment of tuition $75 (non-refundable)</td>
            </tr>
            <tr>
              <td className="border p-2">Official transcripts $10 (includes first class postage) (non-refundable)</td>
            </tr>
            <tr>
              <td className="border p-2">Withdrawal from each course $25 (non-refundable)</td>
            </tr>
            <tr>
              <td className="border p-2">Returned check fee $30 (non-refundable)</td>
            </tr>
            <tr>
              <td className="border p-2">Technology fee per course $30</td>
            </tr>
            <tr>
              <td className="border p-2">Course challenge fee $50 (non-refundable)</td>
            </tr>
            <tr>
              <td className="border p-2">Deferred tuition payment plan fee $25 (non-refundable)</td>
            </tr>
          </tbody>
        </table>

        <p className="mb-4">
          Credit by Portfolio Fee - will be determined based on number of hours granted. <br />
          <a href="?section=catalog&doc=credit_by_portfolio" className="text-blue-500 underline">Click Here for More Information</a>
        </p>

        <h2 className="text-2xl font-bold mb-4">One Time Fees</h2>
        <table className="w-full border-collapse mb-4">
          <tbody>
            <tr>
              <td className="border p-2">Application for admittance $50 (non-refundable)</td>
            </tr>
            <tr>
              <td className="border p-2">Graduation application fee $100 (non-refundable)</td>
            </tr>
          </tbody>
        </table>

        <h2 className="text-2xl font-bold mb-4">Payment Options</h2>
        <p className="mb-4">
          Payment may be tendered in the form of money order, certified bank check, credit/debit card, personal check of company check or via wire.
        </p>

        <h2 className="text-2xl font-bold mb-4">Equipment (technology) needed by students</h2>
        <p className="mb-4">
          In order to take our courses, each student must have access to a personal computer or laptop. Such computer should
          be equipped with an internet access browser. The computer must have access to the internet in order to access our
          online education portal. Some professor may deploy some course material via message boards and email also most all of our courses have a required text book, which may be purchased from most any online bookseller.
        </p>
        <p className="mb-4">Students should budget at least an additional $50 - $100 per course for books.</p>

        <h2 className="text-2xl font-bold mb-4">Deferred tuition payment plan</h2>
        <p className="mb-4">
          Each student full time student must pay for at least three courses to be considered enrolled as a fulltime student. Part
          time Students can pay for one class at a time in the initial registration. After the first three completed course HCB
          may consider approving student who wish to break up the tuition due to the School into monthly payments but this
          will be determined on an individual bases.. The School will require 25% of the total to be paid by the beginning of the
          term. The remaining balance will be broken into two additional monthly payments. The final payment must be made
          by the close of the final day of classes of the term in order for the course to be graded and count toward degree and
          program.
        </p>
        <p className="mb-4">
          Students may not carry a balance on their account from one term to the next. All financial obligations for each term
          must be settled within the current term.
        </p>
        <p className="mb-4">
          The School will access a $25 non-refundable administrative charge each time the student chooses to use this plan.
        </p>
      </div>
    </div>
  );
};

export default Tuition;